var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lyf-ui-action-bar-placeholder",class:{
  'bar-placeholder' : _vm.placeholder,
  'save-area': _vm.safeAreaInsetBottom
}},[_c('div',{staticClass:"lyf-ui-action-bar",class:{
    'save-area': _vm.safeAreaInsetBottom,
    disabled: _vm.disabled
  }},[_vm._t("default"),_c('div',{staticClass:"lyf-ui-action-button",style:({
        backgroundColor: _vm.buttonBackground
      }),on:{"click":_vm.buttonClick}},[_vm._v(_vm._s(_vm.buttonText))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }